module.exports = __webpack_public_path__ + "media/images/icons/gmail-f12319849e28413aaa94f1c11fd35eef.svg";